<template>
  <div class="payment-proof-modal--overlay">
    <div class="payment-proof-modal">
      <button
        class="payment-request-modal__btn-close"
        @click="$emit('close')"
      >
        <svg-loader src="/static/images/icon-close-small.svg" />
      </button>
      <div class="payment-proof-modal__header">
        <h5
          v-if="showMessagePaymentConfirmed"
          class="payment-success"
        >
          <svg-loader src="/static/images/exam-mask/check.svg" /> Pagamento recebido com sucesso
        </h5>
        <h4>Solicitação de Crédito</h4>
        <h6>Pedido Pago</h6>
      </div>

      <div
        v-if="isLoading"
        class="payment-proof-modal__loading"
      >
        <Spinner />
      </div>
      <template v-else>
        <SummaryOrder
          class="payment-proof-modal__summary"
          :summary-data="paymentProofData"
        />

        <button
          class="payment-proof-modal__download-btn md-button btn btn-primary"
          @click="downloadPaymentProof"
        >
          <svg-loader src="/static/images/print-batch.svg" />
          Comprovante
        </button>

        <div class="payment-proof-modal__footer">
          <p>
            <span class="icon-info"> i </span>
            Esta solicitação já foi realizado o pagamento.
          </p>
          <p>Em caso de dúvida entre em contato com o <strong>Suporte</strong>.</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import notify from '@/api/notification'
import paymentsService from '@/api/payments'

import Spinner from '../../common/Spinner'
import SummaryOrder from './SummaryOrder'

import { saveAs } from 'file-saver'

export default {
  name: 'PaymentProofModal',
  components: {
    SummaryOrder,
    Spinner
  },
  props: {
    summaryData: {
      required: true,
      type: Object
    },
    showMessagePaymentConfirmed: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      paymentProofData: null
    }
  },
  mounted() {
    this.isLoading = true
    paymentsService
      .getPaymentProof(this.summaryData.paymentId)
      .then(res => {
        this.paymentProofData = res.data
        this.isLoading = false
      })
      .catch(err => {
        console.error('err -------->', err.response.data)
        notify({
          title: 'AVISO:',
          message: err.response.data.message
        })
      })
  },
  methods: {
    async downloadPaymentProof() {
      try {
        const res = await paymentsService.getPaymentProofDownload(this.summaryData.paymentId)

        const blob = new Blob([res.data], { type: 'application/pdf' })
        saveAs(blob, 'comprovante.pdf')
      } catch (err) {
        console.log('err -------->', err)
        notify({
          title: 'AVISO:',
          message: err.response?.data?.message || 'Erro ao baixar o comprovante'
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .payment-proof-modal {
    background-color: #ffffff;
    padding: 48px 80px;
    border-radius: 10px;
    color: #363636;
    position: relative;

    .payment-success {
      font-size: 16px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      i {
        margin-right: 8px;
      }
    }

    h4 {
      font-size: 18px;
    }

    h6 {
      font-size: 14px;
      font-weight: 400;
    }

    &--overlay {
      position: fixed;
      background-color: rgba(0, 0, 0, 0.7);
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 1040;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__loading {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }

    &__summary {
      margin: 24px 0;
    }

    &__download-btn {
      display: block;
      margin: 0 auto 12px !important;

      .md-icon {
        margin-right: 4px;
      }

      path {
        fill: #ffffff !important;
      }
    }

    &__footer {
      .icon-info {
        display: inline-flex;
        width: 20px;
        height: 20px;
        background-color: #7f1a54;
        color: #fff;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        font-weight: bolder;
        margin-right: 8px;
      }

      p:last-child {
        margin-top: 14px;
      }

      strong {
        color: #7f1a54;
      }
    }
  }
</style>
